import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import logo from '../assets/gliplogowhite.png';
import amplitude from 'amplitude-js';

const Mobile = styled.div`
  display: none;
  background: linear-gradient(180deg, #110F40 0%, #1B1694 100%);
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  background: linear-gradient(180deg, #110F40 0%, #1B1694 100%);
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const Header = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -1px;
    color: #FFFFFF;
    margin-bottom: 38px;
`;

const Button = styled.a`
    background: linear-gradient(90.07deg, #D84F97 29.06%, #ED264A 96.96%);
    border-radius: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    letter-spacing: 0.1px;

    /* Light Button / Primary Foreground */

    color: #FFFFFF;
    width: 100%;
    padding: 12px;
    text-align: center;

`;

var instance1 = amplitude.getInstance().init("8b41da3c9f427c0d043baf50c941bd00");

export default function L2EDownloadPage(props) {


  const handleButtonClick = () => {
    const event = 'download_web_app_clicked';
    amplitude.getInstance().logEvent(event);
  };
 

  return (
    <>
      <Mobile>
            <div style={{
                display: 'flex',
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                padding: 30,
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <img src={logo} style={{width: 75, marginBottom: 70}} />
                <Header>Install Axie Infinity <br></br>& earn SLP crypto</Header>
                <Button onClick={() => handleButtonClick()} href={'https://axieinfinity.com/downloads/axie_infinity_origin-latest-android.apk'}>
                    Click here to download & install
                </Button>
            </div>
      </Mobile>
      <Desktop>
            <div style={{
                display: 'flex',
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                padding: 30,
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <img src={logo} style={{width: 75, marginBottom: 70}} />
                <Header>Install Axie Infinity <br></br>& earn SLP crypto</Header>
                <Button onClick={() => handleButtonClick()}  href={'https://axieinfinity.com/downloads/axie_infinity_origin-latest-android.apk'}
                >Click here to download & install</Button>
            </div>
      </Desktop>
    </>
  );
}

// module.exports = VideoPage;
